<template lang="pug">
  article(:class="{'pt-110 md-pt-67': !hasLanding}")
    transition(name="fade")
      main(v-if="doc")
        breadcrumb-nav(:items="nav")
        //- landing body
        flex-body.lg-mb-140(:rows="doc.acf.landing", v-if="hasLanding")
        //- blue projects body
        blue-projects-index(v-if="slug === 'blue-projects'", :doc="doc")
        //- locations body
        locations(:doc="doc", v-if="slug === 'locations'")
        //- default body
        flex-body(v-else, :rows="doc.acf.body")
        //-
        hostem-overview(:doc="doc")
        article-collection.mt-200(:id="doc.acf.collection", :isLibrary="slug === 'library'")
        further-reading(:doc="doc.acf")
        //- library-feed.mt-120.md-mt-300(v-if="slug === 'library'")
</template>

<script>
import BreadcrumbNav from '@/components/BreadcrumbNav'
import FlexBody from '@/components/FlexBody/FlexBody'
import HostemOverview from '@/components/HostemOverview'
import ArticleCollection from '@/components/ArticleCollection'
import FurtherReading from '@/components/FurtherReading'
import BlueProjectsIndex from '@/components/BlueProjectsIndex'
import LibraryFeed from '@/components/Library__Feed'
import Locations from '@/views/Locations/Locations'
import { plainTitle, linkResolver } from '@/utils'
export default {
  name: 'Page',
  props: ['slug'],
  data () {
    return {
      doc: null
    }
  },
  computed: {
    nav () {
      return this.buildNav(this.doc)
    },
    hasLanding () {
      return this.doc && this.doc.acf.landing && this.doc.acf.landing.length
    }
  },
  methods: {
    buildNav (doc, arr) {
      /*
       *  Recursive function to get parent pages and build breadcrumb nav
      */
      arr = arr || []
      if (!doc) return arr
      // add current to front
      arr.unshift({ txt: doc.title.rendered, rt: linkResolver(doc.link) })
      // current has parent ?
      if (doc.parent) {
        const prnt = Object.values(this.$store.state.pages).find(pg => pg.id === doc.parent)
        if (!prnt) return arr
        // parent has parent ?
        if (prnt.parent) return this.buildNav(prnt, arr) // recursive loop!
        // end of tree
        arr.unshift({ txt: prnt.title.rendered, rt: linkResolver(prnt.link) })
      }
      return arr
    },
    async getDoc () {
      const qry = this.$route.query
      if (qry.id && qry.preview) return this.$store.dispatch('getPreview', { type: 'pages', ...qry })
      return this.$store.dispatch('getPage', this.slug)
    }
  },
  created () {
    this.getDoc().then(doc => { this.doc = doc })
  },
  metaInfo () {
    if (!this.doc) return
    const title = plainTitle(this.doc)
    return {
      title: title,
      meta: this.$store.getters.meta({ title: title })
    }
  },
  components: { BreadcrumbNav, FlexBody, ArticleCollection, FurtherReading, BlueProjectsIndex, LibraryFeed, Locations, HostemOverview }
}
</script>

<style>
</style>
